import { type z } from 'zod'
import { idSchemaV2, isId } from '../ids'

export const CustomFieldIdSchema = idSchemaV2('CF')
export type CustomFieldId = z.infer<typeof CustomFieldIdSchema>
export const isCustomFieldId = isId(CustomFieldIdSchema)
